<template>
  <div class="px-2 py-1">
    <FormInput
      type="search"
      v-model="search"
      :placeholder="placeholder"
      class="mb-6"
    />
    <p class="mb-2 text-xs font-bold">Recommended</p>
    <div class="relative h-64 overflow-y-auto">
      <FormTagBox
        v-if="searchResults.length"
        :model-value="modelValue"
        :tags="searchResults"
        @load-next-page="() => handleSearch(currentPage + 1)"
        :max="max"
        @update:modelValue="updateModelValue"
      />
      <AnimationLoadingDotsHorizontal v-if="loading" class="absolute inset-0 mx-auto flex items-center" />
    </div>
    <p class="mt-4 mb-2 text-xs font-bold">{{maxSelectedCopy}} Selected</p>
    <FormTagBox
      v-if="modelValue.length"
      :model-value="modelValue"
      :tags="modelValue"
      :max="max"
      @update:modelValue="updateModelValue"
    />
    <p v-else class="mt-2 mb-2 text-xs text-slate-300">None yet</p>
  </div>
</template>

<script setup>
import {debounce} from "lodash";
import {computed, onMounted, ref, watch} from "vue";
import AnimationLoadingDotsHorizontal from "./AnimationLoadingDotsHorizontal.vue";
import FormInput from "./FormInput.vue";
import FormTagBox from "./FormTagBox.vue";

const emits = defineEmits(["update:modelValue"]);
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  getOptions: {
    type: Function,
    default: () => {
    },
  },
  recommendedOptions: {
    type: Array,
    default: () => [],
  },
  placeholder: {
    type: String,
    default: "Search...",
  },
  max: Number,
});

const search = ref("");
const searchResults = ref([]);
const currentPage = ref(1);
const loading = ref(false);

const handleSearch = (page=1) => {
  if(loading.value) return;
  loading.value = true;
  props.getOptions({page: page, search: search.value}).then((response) => {
    if(page === 1) searchResults.value = [];
    searchResults.value.push(...response.data.map((item) => item.name));
    currentPage.value = response.meta.current_page;
  }).finally(() => {
    loading.value = false;
  });
};

const maxSelectedCopy = computed(() => {
  if (!props.max) return "";
  return `${props.modelValue.length} of ${props.max}`;
});

const debouncedSearch = debounce(handleSearch, 250);

watch(() => search.value, () => debouncedSearch(1));
onMounted(() => handleSearch());
const updateModelValue = (value) => emits("update:modelValue", value);
</script>
